import { useGetMostViewedNoticesMutation } from '@frontend/redux';
import withNoticeList from './withNoticeList';

const MostViewedNotices = withNoticeList(
  useGetMostViewedNoticesMutation,
);

export default MostViewedNotices;
